export default "__VITE_ASSET__czQOk77B__"